<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-xl-3 col-12 mb-3">
                <div class="card">
                    <div class="card-header blue-gradient">Agrega organización</div>
                    <div class="card-body">
                        <form action="" @submit.prevent="storeCity">
                            <div class="form-group">
                                <label for="name">Nombre completo:</label>
                                <input required type="text" class="form-control" v-model="city.name">
                            </div>
                            <div class="form-group">
                                <label for="name">NIT: </label>
                                <input required type="text" class="form-control" v-model="city.document">
                            </div>
                            <div class="form-group">
                                <label for="name">Dirección: </label>
                                <input required type="text" class="form-control" v-model="city.address">
                            </div>
                            <div class="form-group">
                                <label for="name">Correo: </label>
                                <input required type="email" class="form-control" v-model="city.email">
                            </div>
                            <div class="form-group">
                                <label for="name">Teléfono: </label>
                                <input required class="form-control" v-model="city.phone
                                ">
                            </div>
                            <input class="btn btn-primary mt-3" type="submit" value="Guardar">
                        </form>
                    </div>
                </div>
            </div>
            <div class="col-xl-9 col-12">
                <div class="card">
                    <div class="card-header green-gradient">Organizaciones creadas</div>
                    <div class="card-body">
                        <table class="table table-stripped text-center" id="cities-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Info</th>
                                    <th>Áreas</th>
                                    <th>Eliminar</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(cit, i) in cities" :key="cit.id" :data-index="i">
                                    <td width="30px">{{i+1}}</td>
                                    <td>
                                        <p style="display: none">
                                            {{cit.name}}
                                            {{cit.document}}
                                            {{cit.address}}
                                            {{cit.email}}
                                            {{cit.phone}}
                                        </p>
                                        <input type="text" placeholder="Nombre" class="ml-1" style="border-radius: 3px; border: none; border-bottom: 1px solid gray" v-model="cit.name">
                                        <input type="text" placeholder="NIT" class="ml-1" style="border-radius: 3px; border: none; border-bottom: 1px solid gray" v-model="cit.document">
                                        <input type="text" placeholder="Dirección" class="ml-1" style="border-radius: 3px; border: none; border-bottom: 1px solid gray" v-model="cit.address">
                                        <input type="text" placeholder="Correo" class="ml-1" style="border-radius: 3px; border: none; border-bottom: 1px solid gray" v-model="cit.email">
                                        <input type="text" placeholder="Teléfono" class="ml-1" style="border-radius: 3px; border: none; border-bottom: 1px solid gray" v-model="cit.phone">
                                    </td>
                                    <td>
                                        <span v-for="zone in cit.zones" :key="zone.id" class="ml-1 badge badge-primary">{{zone.name}}</span>
                                    </td>
                                    <td width="50px">
                                        <a href="#" class="mr-1 btn btn-sm btn-warning" @click.prevent="updateCity(cit)"><i class="fa fa-save"></i></a>
                                        <a href="#" class="btn btn-danger btn-sm" @click="deleteCity(cit, i)"><i class="fa fa-window-close"></i></a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
export default {
    name: 'cities',
    mounted: function(){
        this.fetchCities();
    },
    data(){
        return {
            baseUrl: process.env.VUE_APP_API,
            cities: [],
            city: {},
            table: null,
            currentCity: null,
        }
    },
    methods: {
        fetchCities: function(){
            
            let loader = this.$loading.show();
            
            let _this = this;
            this.$http
            .get(`${this.baseUrl}/public/cities`)
            .then(data => {
                _this.cities = data.body.data;
                var casesTable = $("#cities-table");
                window.setTimeout(()=>{this.renderTable(casesTable)}, 0);
                loader.hide();

            })
            .catch(error => {
                console.log(error.error);
                loader.hide();
            });
        },
        storeCity: function(){
            let loader = this.$loading.show();
            this.$http.post(`${this.baseUrl}/admin/cities`, this.city)
            .then(data => {
                console.log(data);
                this.fetchCities();
                loader.hide();
                this.city="";
                window.location.reload();

            })
            .catch(error => {
                loader.hide();
                this.$dialogs.alert("Ya existe una organización con ese nombre", {title: 'Error', size: 'sm'});
                this.city="";

            });

        },
        deleteCity(city, i){
            this.$dialogs.confirm(`¿Desea borrar la organización ${city.name}?`, {title: "Eliminar", size: "sm", okLabel: "Sí", cancelLabel: "Cancelar"})
            .then(response => {
                if(response.ok){
                    const loader = this.$loading.show();
                    const requestUrl = `${this.baseUrl}/admin/cities/${city.id}`;
                    this.$http.delete(requestUrl,
                    {headers: {Authorization: `Bearer ${localStorage.getItem('session_id')}`}})
                    .then(data => {
                        this.$dialogs.alert("Organización borrada con éxito", {title: "Éxito", size: "sm"});
                        this.cities.splice(i, 1);
                        loader.hide();

                    })
                    .catch(error => {
                        if(error.status == 409){
                            this.$dialogs.alert("No se puede eliminar la organización, porque tiene áreas asignadas", {title: "Error", size: "sm"});
                            loader.hide();
                        }
                    });
                }
            });

            
        },
        updateCity(city){
            const loader = this.$loading.show();
            const requestUrl = `${this.baseUrl}/admin/cities/${city.id}`;
            this.$http.put(requestUrl, city)
            .then(data => {
                this.$dialogs.alert("Organización actualizada con éxito", {title: "Éxito", size: "sm"});
                loader.hide();
            })
            .catch(error => {
                if(error.status == 409){
                    loader.hide();
                    this.$dialogs.alert("No se puede actualizar la organización ya que tiene áreas asignadas", {title: "Error", size: "sm"}).then(()=>{
                        window.location.reload();

                    });
                } else if(error.status == 422){
                    loader.hide();
                    let errors = "";
                    for(let err in error.body){
                        errors+=error.body[err][0];
                    }

                    this.$dialogs.alert(errors, {title: "Error", size: "sm"}).then(()=>{
                        window.location.reload();
                    });
                    
                }
            })
        },
        renderTable(table){
            if(this.table != null){
                this.table.destroy();
            }

            this.table = table.DataTable({
                destroy: true,
                "language": {
                    "sProcessing":     "Procesando...",
                    "sLengthMenu":     "Mostrar _MENU_ registros",
                    "sZeroRecords":    "No se encontraron resultados",
                    "sEmptyTable":     "Ningún dato disponible en esta tabla",
                    "sInfo":           "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
                    "sInfoEmpty":      "Mostrando registros del 0 al 0 de un total de 0 registros",
                    "sInfoFiltered":   "(filtrado de un total de _MAX_ registros)",
                    "sInfoPostFix":    "",
                    "sSearch":         "Buscar:",
                    "sUrl":            "",
                    "sInfoThousands":  ",",
                    "sLoadingRecords": "Cargando...",
                    "oPaginate": {
                        "sFirst":    "Primero",
                        "sLast":     "Último",
                        "sNext":     "Siguiente",
                        "sPrevious": "Anterior"
                    },
                    "oAria": {
                        "sSortAscending":  ": Activar para ordenar la columna de manera ascendente",
                        "sSortDescending": ": Activar para ordenar la columna de manera descendente"
                    }
                }
            });
        }
    }

}
</script>
<style lang="sass" scoped>
    @import '../../assets/scss/colors';
</style>


